import React from "react";
import Cookies from 'universal-cookie';

// components
import PageTitle from "../components/PageTitle/PageTitle";
import Loading from "../components/Loading";
import checkToken from "../services/checkToken";
import Table from '../widgets/tables/Table';

// apis
import getAllDdt from "../services/getAllDdt";

const cookies = new Cookies();
let username = cookies.get('username', { path: '/' });
let token = cookies.get('token', { path: '/' });

export default class Ddt extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      ddt: []
    };

  }

  async reload() {
    this.setState({ isLoading: true });

    username = cookies.get('username', { path: '/' });
    token = cookies.get('token', { path: '/' });

    const check = await checkToken(username, token, true);
    const userType = parseInt(check.utente.tipo);

    const ddt = await getAllDdt(username, token);
    const ddtCustomized = ddt.map((d) => {
      return {
        ...d,
        stato: d.id_ordine === '0' ? 'ddt-esterno' : 'ddt-interno',
      }
    });

    this.setState({
      isLoading: false,
      isUserType: userType,
      ddt: ddtCustomized
    });
  }

  async componentDidMount() {
    await this.reload();
  }

  render() {

    var headCells = [
      { id: 'rif', numeric: false, disablePadding: true, label: 'Rif' },
      { id: 'cliente', numeric: false, disablePadding: true, label: 'Cliente' },
      { id: 'causale', numeric: false, disablePadding: true, label: 'Causale' },
      { id: 'destinazione', numeric: false, disablePadding: true, label: 'Destinazione' },
      { id: 'data_ritiro', numeric: false, disablePadding: true, label: 'Data Ritiro' },
      { id: 'stato', numeric: false, disablePadding: true, label: 'Stato', chip: true}
    ];

    this.searchColumns = ['causale', 'destinazione'];

    if (this.state.isLoading)
      return <Loading />;

    const cookies = new Cookies();

    return (
      <div id={Math.random()}>

        <PageTitle title="Ddt" button="CREA NUOVO" onClick={() => {
          if(cookies.get('userType') === '4') {
            window.location.href = '/#/service/add-ddt';
          } else if(cookies.get('userType') === '0') {
            window.location.href = '/#/app/add-ddt';
          }
        }} />

        <Table headCells={headCells} searchCols={this.searchCols} rows={this.state.ddt}
          onEventClick={(row) => {
            let found = this.state.ddt.find(d => d.id === row)
            if (!found) {
              alert('Ddt non trovato');
              return;
            }
            if (parseInt(found.id_ordine) === 0) {
              cookies.set('ddt', row, { path: '/' });
              let path = '/#/app/edit-ddt/'
              if (cookies.get('userType') === '4') {
                path = '/#/service/edit-ddt/'
              }
              window.location.href = path;
            } else {
              cookies.set('ordine', found.id_ordine, { path: '/' });
              let path = '/#/app/edit-ordine/'
              if (cookies.get('userType') === '4') {
                path = '/#/service/edit-ordine/'
              }
              window.location.href = path;
            }
          }}
        />

      </div>
    );
  }
}

